
import { Component } from '@angular/core'
import { OrderWizardItsMeLoginComponent } from '../../order/wizard/step-03/itsme-login/button/itsme-login-button.component';

@Component({
    selector: 'app-testitsme',
    templateUrl: './testitsme.component.html',
    styleUrls: ['./testitsme.component.scss'],
    imports: [OrderWizardItsMeLoginComponent]
})
export class TestItsMeComponent {  
}